import { Warning } from '../../../assets/icons'
import { SVGWrapper } from '../../../components'
import { Section } from '../styles'
import dayjs from 'dayjs'

const CatchUp60To63 = ({ standardLimit, standardCatchup, additionalCatchup }) => {
  return (
    <Section.ActionItemsMessage warning>
      <SVGWrapper svg={Warning} fill='#3A4D57' size='large' />{' '}
      <Section.ActionItemMessageText>
        You have the chance to save a little more: The IRS permits those aged 60-63 in the current
        calendar year to make a higher catch-up contribution to their company’s retirement plan. The
        standard contribution limit in {dayjs().year()} is ${standardLimit?.toLocaleString()} and
        the standard catch-up contribution limit is $
        {standardCatchup?.maximumAmount?.toLocaleString()}. With the higher catch-up contribution
        limit, you may contribute up to an additional $
        {(additionalCatchup?.maximumAmount - standardCatchup?.maximumAmount).toLocaleString()} for a
        total catch-up contribution of ${additionalCatchup?.maximumAmount?.toLocaleString()}, making
        the retirement plan account maximum contribution $
        {(standardLimit + additionalCatchup?.maximumAmount)?.toLocaleString()}.
      </Section.ActionItemMessageText>
    </Section.ActionItemsMessage>
  )
}
export default CatchUp60To63
